import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'

import ResumeWatchingModal from '../../components/ResumeWatchingModal/ResumeWatchingModal'
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer'
import { PlayerType } from '../../components/VideoPlayer/types'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import { getInitialPlayheadPosition, resetWatchHistory } from './utils'
import { useIsAdsEnabled } from '../../../../shared/providers/FeatureTogglesProvider'

function VideoPlayerContainer() {
  const videoDetails = useAppSelector((state) => state.content.videoDetails)
  const deviceHasAdsEnabled = useAppSelector((state) => state.device.adsEnabled)
  const initialPlayheadPosition = useRef(
    getInitialPlayheadPosition(
      videoDetails.seconds_watched,
      videoDetails.duration
    )
  )
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [showResumeWatching, setShowResumeWatching] = useState(false)
  const [showVideoPlayer, setShowVideoPlayer] = useState(false)
  const {
    isAdsEnabled: featureFlagAdsEnabled,
    isLoading: loadingAdsFeatureFlag,
  } = useIsAdsEnabled()
  const playerType = videoDetails.drmWidevideLicenseUrl
    ? PlayerType.DRM
    : PlayerType.NO_DRM

  const shouldStartFromBeginning: boolean =
    initialPlayheadPosition.current === 0

  const adsEnabled =
    featureFlagAdsEnabled &&
    deviceHasAdsEnabled &&
    videoDetails.duration > 60 * 3 &&
    playerType === PlayerType.NO_DRM &&
    shouldStartFromBeginning

  useEffect(() => {
    if (shouldStartFromBeginning) {
      setShowVideoPlayer(true)
    } else {
      setShowResumeWatching(true)
    }
  }, [])

  const handleResumeWatching = () => {
    setShowVideoPlayer(true)
    setShowResumeWatching(false)
  }

  const handlePlayFromBeginning = () => {
    const newVideoDetails = { ...videoDetails, seconds_watched: 0 }
    dispatch({
      type: 'SET_VIDEO_DATA',
      payload: { videoDetails: newVideoDetails },
    })
    resetWatchHistory(newVideoDetails.videoId)
    initialPlayheadPosition.current = 0
    setShowVideoPlayer(true)
    setShowResumeWatching(false)
  }

  const handleBackPress = () => {
    const windowUrl = window.location.pathname.split('/')[2]
    navigate(`/video-details/${windowUrl}`, {
      replace: true,
      state: { fromResumeModal: true },
    })
  }

  return (
    <>
      {showResumeWatching && (
        <ResumeWatchingModal
          onResumeWatching={handleResumeWatching}
          onPlayFromBeginning={handlePlayFromBeginning}
          onBackPress={handleBackPress}
        />
      )}
      {showVideoPlayer && (
        <VideoPlayer
          initialPlayheadPosition={initialPlayheadPosition.current}
          adsEnabled={adsEnabled}
          loadingAdsFeatureFlag={loadingAdsFeatureFlag}
        />
      )}
    </>
  )
}

export default VideoPlayerContainer
